module.exports = (__webpack_require__(11))(3);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/object-assign/index.js from dll-reference vendor_lib
// module id = 23
// module chunks = 0